export default "__VITE_ASSET__CnCn595S__"